<template>
  <div>
    <div class="text-body1 text-weight-bold text-negative q-mb-sm">
      Delete Account
    </div>
    <p class="text-body1">
      All posts related to this account will be <strong>permanently deleted</strong>
      from Private Footprint.
      This has no impact on the client's actual {{ platform.name }} account.
    </p>
    <delete-account-btn :social-account="account" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Account, Platform } from '@/social/types';
import DeleteAccountBtn from './action/delete/DeleteAccountBtn.vue';

export default defineComponent({
  components: { DeleteAccountBtn },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  computed: {
    platform(): Platform {
      return this.account.socialSite;
    },
  },
});
</script>
